export enum UsersTabs {
  MANAGE_USERS = 'Manage Users',
  RANKS = 'Ranks',
}
